module.exports = __webpack_public_path__ + "static/media/banner_l_05.9249d709.jpg";